import Vuex from "vuex";
import Vue from "vue";
import axios from "axios";
import router from "@/router";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    filters: [],
    results: [],
    params: [],
    tourCategoryTitle: window.tourFilterData.tourCategoryTitle,
    urlPrefix: window.tourFilterData.requestFilterUrl,
    imagePrefixAddress: window.tourFilterData.imagePrefixAddress,
    filterUrlPrefix: window.tourFilterData.requestFilterItemUrl,
    addToFavoritePrefix: window.tourFilterData.favoriteUrl,
    isUserAuthenticated:
      window.tourFilterData.isUserAuthenticated === "True" ? true : false,
    sortPrefix: "sort",
    sortType: 64,
    totalResultCount: 0,
    showLoadMore: false,
    openFilterMobile: false,
    loading: true,    
    pageNumber: 1,
  },

  getters: {
    getTourCategoryTitle(state) {
      return state.tourCategoryTitle;
    },

    getImagePrefixAddress: (state) => {
      return state.imagePrefixAddress;
    },

    getIsUserAuthenticated: (state) => {
      return state.isUserAuthenticated;
    },

    getFavoritePrefix: (state) => {
      return state.addToFavoritePrefix;
    },

    getLoading: (state) => {
      return state.loading;
    },

    getDataParams: (state) => {
      if (state.params.length > 0) {
        return "/" + state.params.join("/");
      }
      return "";
    },

    getPageParams: (state) => {
      if (state.pageNumber > 1) {
        return "/page/" + state.pageNumber;
      }
      return "";
    },

    getUrlPrefix: (state) => {
      return state.urlPrefix;
    },

    getFilterUrlPrefix: (state) => {
      return state.filterUrlPrefix;
    },

    createFilterRequestData: (state, getters) => {
      return (
        "/" + state.sortPrefix + "/" + state.sortType + getters.getDataParams
      );
    },

    createLoadMoreRequestData: (state, getters) => {
      return (
        "/" + state.sortPrefix + "/" + state.sortType + getters.getPageParams
      );
    },

    getPageNumber: (state) => {
      return state.pageNumber;
    },

    getResultCount: (state) => {
      return state.totalResultCount;
    },

    getOpenFilterMobile: (state) => {
      return state.openFilterMobile;
    },

    getSortType: (state) => {
      return state.sortType;
    },
  },

  actions: {
    postRequest(context, payload) {
      axios({
        method: "post",
        url: payload.url,
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
        data: payload.data,
      }).then((response) => {
        if (response.data.isSucceed) {
          payload.payload(response);
        }
      });
    },
    
    updatePageNumber(context, pageNumber) {
      context.commit("UPDATE_PAGE_NUMBER", Number(pageNumber));
    },

    fetchFilters(context, url) {
      const requestFilterData = {
        url: url,
        payload: (response) => {
          context.commit("updateFilterItems", response.data.filters);
        },
      };
      context.dispatch("postRequest", requestFilterData);
    },

    fetchFilterData(context, url) {
      var data = new FormData();
      data.set("params", context.getters.createFilterRequestData);
      context.dispatch("updatePageNumber", 1);

      const requestFilterData = {
        url: url,
        data: data,
        payload: (response) => {
          context.commit("updateFilterResult", response.data.result.tours);
          context.commit("fillTotalCount", response.data.result.totalCount);
          context.dispatch("showLoadMore");
          context.dispatch("changeLoading", false);
        },
      };
      context.dispatch("postRequest", requestFilterData);
    },

    createUrlPath(context) {
      const params = `${context.getters.createFilterRequestData}${context.getters.getPageParams}`;

      if (router.currentRoute.path !== params) router.push(params);
    },

    addToFavorite(context, data) {
      var favoriteRequest = {
        EntityRef: data.entityRef,
        EntityType: data.entityType,
        IsFavorit: true,
      };

      data.element.setAttribute("disabled", true);

      const requestFilterData = {
        url: data.url,
        data: favoriteRequest,
        payload: (response) => {
          if (response.data.isSucceed) {
            data.element.removeAttribute("disabled", true);

            context.dispatch("showAlert", {
              messages: response.data.messages,
            });

            data.element.classList.toggle("is-bookmarked");
          }
        },
      };
      context.dispatch("postRequest", requestFilterData);
    },

    createRangeFilterItem(context, items) {
      return new Promise((resolve) => {
        let rangeFilterItems = [];
        rangeFilterItems.push(...items);
        let rangeFilterValue = rangeFilterItems.join("_");
        resolve(rangeFilterValue);
      });
    },

    onChangeFilter(context, payload) {
      context.dispatch("changeLoading", true);

      if (
        payload.showType.toLowerCase() === "list" ||
        (payload.showType.toLowerCase() === "range" &&
          payload.type.toLowerCase() === "rate")
      ) {
        if (payload.isSelected) {
          context.commit("addItemToParams", {
            value: payload.slug,
            type: "check",
          });
          context.dispatch("fetchFilterData", context.getters.getUrlPrefix);
        } else {
          context.commit("removeItemFromParams", payload.slug);
          context.dispatch("fetchFilterData", context.getters.getUrlPrefix);
        }
      } else {
        context
          .dispatch("createRangeFilterItem", [
            payload.slug,
            payload.minimum,
            payload.maximum,
          ])
          .then((rangeFilterValue) => {
            context.commit("addItemToParams", {
              value: rangeFilterValue,
              type: "range",
            });
            context.dispatch("fetchFilterData", context.getters.getUrlPrefix);
          });
      }
    },

    updateSort(context, payload) {
      context.dispatch("changeLoading", true);

      if (payload !== "0") {
        context.commit("updateSortType", payload);
      } else {
        context.commit("updateSortType", "");
      }
      context.dispatch("fetchFilterData", context.getters.getUrlPrefix);
    },

    loadMoreResult(context) {
      var data = new FormData();
      data.set("params", context.getters.createLoadMoreRequestData);

      const loadResultData = {
        url: context.getters.getUrlPrefix,
        data: data,

        payload: (response) => {
          context.commit("addLoadMoreItems", response.data.result.tours);
          context.dispatch("scrollToTop");
        },
      };
      context.dispatch("postRequest", loadResultData);
      context.dispatch("showLoadMore");

    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    showLoadMore({ commit, state }) {
      commit(
        "updateShowMore",
        state.results.length < state.totalResultCount ? true : false
      );
    },

    toggleFilterBoxMobile({ commit }) {
      commit("updateOpenFilterMobile");
    },

    clearFilters(context) {
      context.commit("addParamsList", []);
      context.commit("updateFilterItems", []);
      context.dispatch('fetchFilters',context.getters.getFilterUrlPrefix);
      context.dispatch('fetchFilterData',context.getters.getUrlPrefix + context.getters.getDataParams);
    },

    changeLoading({ commit }, value) {
      commit("updateLoading", value);
    },

    showAlert(context, messages, position = "#js-fixed-alert-wrapper") {
      for (var k in messages.messages) {
        var tmpMessage = [k, messages.messages[k]];
        var boxClass = "",
          iconClass = "";

        if (tmpMessage && tmpMessage[1] && tmpMessage[1].message) {
          var message = tmpMessage[1].message;
          var status = parseInt(tmpMessage[1].type);

          if (!message) {
            message = tmpMessage[0];
            status = parseInt(tmpMessage[1]);
          }
          switch (status) {
            case 1: {
              //Success
              boxClass = "alert--success";
              iconClass = "icon-check";
              break;
            }
            case 8: {
              //Error
              boxClass = "alert--danger";
              iconClass = "icon-close";
              break;
            }
            case 4: {
              //Warning
              boxClass = "alert--warning";
              iconClass = "icon-warning-line";
              break;
            }
            case 2: {
              //Info
              boxClass = "alert--info";
              iconClass = "icon-information-line";
              break;
            }
          }

          var para = document.createElement("div");
          var paraText = document.createElement("span");
          var paraIcon = document.createElement("i");

          var node = document.createTextNode(message);
          paraText.appendChild(node);

          paraIcon.classList.add(iconClass);

          para.appendChild(paraIcon);
          para.appendChild(paraText);

          para.classList.add("alert", boxClass);

          var alertId = "js-message-" + Date.now();

          para.setAttribute("id", alertId);

          var element = document.querySelector(position);

          if (element) {
            element.appendChild(para);
          } else {
            document.querySelector("body").appendChild(para);
          }

          setTimeout(function() {
            document.getElementById(alertId).style.height = 0;
            document.getElementById(alertId).remove();
          }, 7000);
        }
      }
    },   
  },

  mutations: {
    updateLoading(state, value) {
      state.loading = value;
    },
    UPDATE_PAGE_NUMBER(state, value) {
      state.pageNumber = value ? value : state.pageNumber++;
    },
    addParamsList(state, defaultParams) {
      state.params = [...defaultParams];
    },
    updateFilterItems(state, filters) {
      state.filters = filters;
    },

    updateFilterResult(state, results) {
      state.results = [...results];
    },

    addItemToParams(state, payload) {
      if (payload.type === "range") {
        let itemIsAded = false;
        let firstItemValue = payload.value.split("_")[0];
        state.params.map((param, index) => {
          if (param.includes(firstItemValue)) {
            state.params.splice(index, 1);
            state.params.push(payload.value);
            itemIsAded = true;
            return;
          }
        });
        if (!itemIsAded) {
          state.params.push(payload.value);
        }
      } else if (
        payload.type === "check" &&
        !state.params.includes(payload.value)
      ) {
        state.params.push(payload.value);
      }
    },

    removeItemFromParams(state, payload) {
      for (let i = 0; i < state.params.length; i++) {
        if (state.params[i] === payload) {
          state.params.splice(i, 1);
        }
      }
    },

    updateSortType(state, payload) {
      state.sortType = payload;
    },

    fillTotalCount(state, payload) {
      state.totalResultCount = payload;
    },

    updatePageNumber(state) {
      state.pageNumber++;
    },

    addLoadMoreItems(state, payload) {
      state.results = [...payload];
    },

    updateShowMore(state, payload) {
      state.showLoadMore = payload;
    },

    updateOpenFilterMobile(state) {
      state.openFilterMobile = !state.openFilterMobile;
      if (state.openFilterMobile) {
        document.querySelector("body").classList.add("no-scroll");
      } else {
        document.querySelector("body").classList.remove("no-scroll");
      }
    },
  },
});
